import moment from "moment";
import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
	PacientesProps,
	UserProps,
} from "../../interfaces/pacientes.interface";
import { TypesErrorRequest } from "../../utils/types";
import { AppActions } from "../ducks/app";
import { ConfigsActions } from "../ducks/configs";
import { RelatorioActions, Types } from "../ducks/relatorios";
import * as Sentry from "@sentry/react";
import { useDispatch, useSelector } from "react-redux";
import { DashBoardActions } from "../ducks/dashboard";
import axios from "axios";
import { getQuarter, sendErrorSentryOrLocalHost } from "../../utils/funcs";
import { apiFetch, apiFetchWrite } from "../../services/httpClient";

function* PersonalizarRelatorio({ payload }: any): any {
	const current_language: any = yield select(
		(state) => state.configs.current_language
	);
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const dat = {
				...payload,
				txDataHora: moment(new Date()).format("YYYY-MM-DD HH:mm:ss").toString(),
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(dat),
			};
			const res = await apiFetchWrite(
				`${process.env.REACT_APP_BASE_URL_V7}configs/relatorios_salvar`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e, {
				message: "Erro ao personalizar relatório - PersonalizarRelatorio",
				tags: {
					endpoint: "configs/relatorios_salvar",
					file: "src/store/sagas/relatorios.ts",
				},
				payload: payload,
			});
			throw e;
		}
	}

	try {
		const response = yield call(apiCall);

		let message: any = "";
		if (response.status == TypesErrorRequest.FAIL) {
			if (response.code == 1) {
				message = current_language?.falha_personalizacao;
			}

			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: message,
				})
			);
		} else {
			//msg de sucesso
			if (response.code == 0) {
				message = current_language?.personalizacao_concluida;
			}

			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.SUCCESS,
					message_toast: message,
				})
			);
		}
	} catch (e) {
	} finally {
		yield put(RelatorioActions.personalizar_relatorio_request_cancel());
		yield put(ConfigsActions.config_request());
	}
}

function* Exportar(): any {
	const language: any = yield select((state) => state.configs.language);
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			// const dat = {
			//   TOKEN: user_logado.token
			// };
			const requestOptions: any = {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};
			const res = await apiFetch(
				`${
					process.env.REACT_APP_BASE_URL
				}relatorios/exportar_csv.php?l=${language?.toLowerCase()}&t=${
					user_logado.token
				}`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			throw e;
		}
	}

	try {
		const response = yield call(apiCall);
	} catch (e) {
	} finally {
	}
}

function* Compartilhar({ payload }: any): any {
	const current_language: any = yield select(
		(state) => state.configs.current_language
	);

	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const dat = {
				...payload,
				TOKEN: user_logado?.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(dat),
			};
			const res = await apiFetchWrite(
				`${process.env.REACT_APP_BASE_URL_V7}relatorios/relatorio_pdf`,
				requestOptions
			);
			const response: any = await res.json();

			if (
				payload.txOutput === "download" &&
				response.status === TypesErrorRequest.SUCCESS
			)
				window.open(response.message);

			return { ...response, ...payload };
		} catch (e) {
			sendErrorSentryOrLocalHost(e, {
				message: "Erro ao compartilhar relatorio - Compartilhar",
				tags: {
					endpoint: "/relatorios/pdf",
					file: "src/store/sagas/relatorios.ts",
				},
				payload: payload,
			});
			throw e;
		}
	}

	try {
		const response = yield call(apiCall);
		let message: any = "";
		if (response.status == TypesErrorRequest.FAIL) {
			if (response.code == -1) {
				message = `${current_language?.erro_gerar_relatorio} ${response?.txTipo}. ${current_language?.sem_dados_exportar}`;
			}
			if (response.code == 1) {
				message = `${current_language?.erro_gerar_relatorio} ${response?.txTipo}. ${current_language?.falha_smtp}`;
			}

			if (response.code === 2) {
				message = `${current_language?.erro_gerar_relatorio} ${response?.txTipo}. ${response?.message}`;
			}

			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: message,
				})
			);
		} else {
			if (response.code == 0) {
				if (response.message == "Email enviado.") {
					message = current_language?.email_enviado;
				} else {
					message = response.message;
				}
				yield put(AppActions.set_modal_compartilhamento(false, 0));
				yield put(
					AppActions.set_toast_visible({
						status_toast: true,
						type_toast: TypesErrorRequest.SUCCESS,
						message_toast: message,
					})
				);
			}
		}
	} catch (e) {
		yield put(
			AppActions.set_toast_visible({
				status_toast: true,
				type_toast: TypesErrorRequest.FAIL,
				message_toast: "500 - Não foi possivel emitir o relatório",
			})
		);
	} finally {
		yield put(RelatorioActions.set_atribuir_tags_cancel());
	}
}

function* EmitirRelatorio(): any {
	const language: any = yield select((state) => state.configs.language);
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	const patient: PacientesProps = yield select(
		(state: any) => state.app.is_open_paciente
	);

	const current_period = yield select(
		(state: any) => state.relatorios.current_selected_period
	);

	let current_selected_exercises = yield select(
		(state: any) => state.relatorios.current_selected_exercises
	);

	const current_selected_reports = yield select(
		(state: any) => state.relatorios.current_selected_reports
	);

	const current_language: any = yield select(
		(state) => state.configs.current_language
	);
	const emit_type_report = yield select(
		(state: any) => state.relatorios.emit_type_report
	);

	current_selected_exercises = current_selected_exercises.map(
		(item: number) => {
			return {
				ID_EXERCICIO: item,
				MODOS: [],
			};
		}
	);

	async function apiCall() {
		const config = {
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + user_logado.token,
			},
		};

		const dat = {
			txDataHora: moment(new Date()).format("YYYY-MM-DD HH:mm:ss").toString(),
			ID_USUARIO: patient.ID_USUARIO,
			txIdioma: language.toLowerCase(),
			txTipo: "unificado",
			txOutput: "download",
			txEmail: "",
			txPeriodo: current_period,
			txSecoes:
				emit_type_report == "EVA" ||
				(current_selected_reports.includes("EVA") &&
					current_selected_reports.length == 1)
					? ["EVA"]
					: current_selected_reports,
			txExercicios:
				emit_type_report == "EVA" ||
				(current_selected_reports.includes("EVA") &&
					current_selected_reports.length == 1)
					? []
					: current_selected_exercises,
		};
		const URL = `${process.env.REACT_APP_BASE_URL_V7}relatorios/relatorio_pdf`;

		try {
			return await axios.post(URL, dat, config);
		} catch (error: any) {
			sendErrorSentryOrLocalHost(error, {
				message: "Erro ao emitir relatório - EmitirRelatorio",
				tags: {
					endpoint: "/relatorios/relatorio_pdf",
					file: "src/store/sagas/relatorios.ts",
				},
			});
			throw error;
		}
	}

	try {
		const response = yield call(apiCall);

		let message: any = "";

		if (response.data.status == TypesErrorRequest.SUCCESS) {
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.SUCCESS,
					message_toast: "Relatório emitido com sucesso",
				})
			);
			const currentQuarter = getQuarter("2025-09-05");
			yield put(RelatorioActions.sync_last_report_emission());
			window.open(response.data.message, "_blank", "noopener,noreferrer");
			yield put(DashBoardActions.set_current_page("perfil_paciente"));
			yield put(RelatorioActions.set_emit_type_report(""));
			yield put(DashBoardActions.set_request_verify_answer_nps(currentQuarter));
			yield put(ConfigsActions.set_request_plan_services());
		}

		if (response.data.status == TypesErrorRequest.FAIL) {
			if (response.data.code == -1) {
				message = `${current_language?.erro_gerar_relatorio} ${response.data?.txTipo}. ${current_language?.sem_dados_exportar}`;
			}
			if (response.data.code == 1) {
				message = `${current_language?.erro_gerar_relatorio} ${response.data?.txTipo}. ${current_language?.falha_smtp}`;
			}

			if (response.data.code === 2) {
				message = `${current_language?.erro_gerar_relatorio} ${response.data?.txTipo}. ${response.data?.message}`;
			}

			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast:
						message ||
						response.data?.message ||
						current_language?.erro_gerar_relatorio,
				})
			);
		}
	} catch (e) {
		yield put(
			AppActions.set_toast_visible({
				status_toast: true,
				type_toast: TypesErrorRequest.FAIL,
				message_toast: "Exception - Não foi possivel emitir o relatório",
			})
		);
	} finally {
	}
}

function* getDataLastEmission() {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const data = {
				TOKEN: user_logado?.token,
				txTipo: "unificado",
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(data),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/ultima_emissao`,
				requestOptions
			);
			const response: any = await res.json();

			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e, {
				message:
					"Erro ao buscar dados da ultima emissao de pdf - getDatalastEmission",
				tags: {
					endpoint: "/syncs/ultima_emissao_pdf",
					file: "src/store/sagas/relatorios.ts",
				},
			});
			throw e;
		}
	}

	try {
		const response: { ultima_emissao: any } = yield call(apiCall);
		if (response.ultima_emissao) {
			yield put(
				RelatorioActions.set_data_last_report_issued(response.ultima_emissao)
			);
			if (response.ultima_emissao?.LOG_RELATORIO_EMITIDO) {
				const dateReference = moment("15-09-2025", "DD-MM-YYYY");
				const dateTest = moment(
					response.ultima_emissao?.LOG_RELATORIO_EMITIDO,
					"YYYY-MM-DD HH:mm:ss"
				);
				const result = dateTest.isSameOrAfter(dateReference, "day");
				if (result) {
					yield put(
						DashBoardActions.set_request_verify_answer_nps(
							getQuarter("2025-09-05")
						)
					);
				}
			}
		}
	} catch (e) {}
}

export function* PersonalizarRelatorioSaga(): any {
	return yield all([
		takeLatest(Types.REQUEST_PERSONALIZAR_RELATORIO, PersonalizarRelatorio),
		takeLatest(Types.SET_COMPARTILHAR, Compartilhar),
		takeLatest(Types.EXPORTAR, Exportar),
		takeLatest(Types.GET_EMITIR_RELATORIO, EmitirRelatorio),
		takeLatest(Types.SYN_LAST_EMISSION, getDataLastEmission),
	]);
}
